import { Injectable } from '@angular/core';
import { ApexOptions } from 'ng-apexcharts';
import {
  ForecastChartApiResponse,
  forecastChartObj,
} from '@reenstudio/app/core/models/charts/forecast-model';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class ForecastChartService {
  public chartOptions: Partial<ApexOptions>;

  getForecastData(
    data: ForecastChartApiResponse[],
    forecastChartObj: forecastChartObj
  ) {
    forecastChartObj.series = [
      {
        name: 'Consumi',
        // type: 'area',
        color: '#26A0FC',
        // data: data.map((item) => item.consumption),
        data: data.map((item) => ({
          x: moment(item.hour).toDate().getTime(),
          y: item.consumption,
        })),
      },
      {
        name: 'Produzione',
        // type: 'area',
        color: '#26E7A6',
        // data: data.map((item) => item.product),

        data: data.map((item) => ({
          x: moment(item.hour).toDate().getTime(),
          y: item.product,
        })),
      },
    ];

    forecastChartObj.formattedDates = data.map((item) =>
      moment(item.hour).format('HH:mm')
    );

    forecastChartObj.overWriteFormattedDates = data.map((item) => {
      const hour = moment(item.hour).format('HH:mm');
      if (hour === '12:00') {
        return moment(item.hour).format('DD/MM/YYYY');
      } else {
        return '';
      }
    });

    return forecastChartObj;
  }

  setForecastChart(forecastChartObj: forecastChartObj): Partial<ApexOptions> {
    this.chartOptions = {
      series: forecastChartObj.series,
      chart: {
        height: 350,
        type: 'area',
      },
      dataLabels: {
        enabled: false,
        enabledOnSeries: [0, 1],
      },
      markers: {
        size: [4, 4, 0, 0],
        showNullDataPoints: false,
        fillOpacity: 1,
        colors: ['#137333', '#004582'],
        strokeColors: ['#137333', '#004582'],
      },
      stroke: {
        curve: 'smooth',
      },
      grid: {
        row: {
          colors: ['#f3f3f3', 'transparent'],
          opacity: 1,
        },
      },
      xaxis: {
        categories: forecastChartObj.formattedDates,
        overwriteCategories: forecastChartObj.overWriteFormattedDates,
        labels: {
          show: true,
          rotate: 0,
        },
      },
      yaxis: {
        labels: {
          formatter: function (val: any) {
            return (+val / 1000).toFixed(1) + 'kW';
          },
        },
      },
      tooltip: {
        x: {
          formatter: function (val) {
            return moment(val).format('DD/MM/YYYY HH:mm');
          },
        },
      },
    };

    return this.chartOptions;
  }
}
